const USER_NOTIFICATION = {
  noResults: 'No results found',
};

Object.freeze(USER_NOTIFICATION);

export { USER_NOTIFICATION };
